import s from './index.module.scss';
import { ReactElement } from 'react';

type Props = {
  children: ReactElement;
  open: boolean;
};

export const CharityDonationTemplate = () => {
  return (
    <div className={s['charity-donation-template']}>
      <div className={s['charity-donation-template-left']}>
        <div className={s['group--root']}>
          <div className={s.group}>
            <div className={s.image}></div>
            <div className={s.lines}>
              <div></div>
              <div></div>
            </div>
            <div className={`${s.lines} ${s['lines--85']}`}>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={s['image--140px']}></div>
        </div>
      </div>
      <div className={s['charity-donation-template-right']}>
        <div className={s['group--root']}>
          <div className={s.group}>
            <div className={s['image--fullwidth-192px']}></div>
            <div className={s['navigation']}>
              <div></div>
              <div></div>
            </div>
            <div className={s['image--fullwidth-52px']}></div>
            <div className={s['group--compact']}>
              <div className={`${s.lines} ${s['lines--128px']}`}>
                <div></div>
              </div>
              <div className={s['image--268px']}></div>
            </div>
            <div className={s['group--compact']}>
              <div className={`${s.lines} ${s['lines--128px']}`}>
                <div></div>
              </div>
              <div className={s['image--268px']}></div>
            </div>
            <div className={s['group--compact']}>
              <div className={`${s.lines} ${s['lines--128px']}`}>
                <div></div>
              </div>
              <div className={s['image--268px']}></div>
            </div>
          </div>
          <div className={s['image--fullwidth-52px']}></div>
        </div>
      </div>
    </div>
  );
};

const Skeleton = ({ children, open }: Props) => {
  if (!open) {
    return null;
  }

  return (
    <div className={s.wrapper} data-component="donation-modal-skeleton">
      <div className={s.skeleton}>{children}</div>
    </div>
  );
};

export default Skeleton;
